// extracted by mini-css-extract-plugin
export default {"wrap":"tt-z","fullWidth":"ut-z","searchPlacement":"vt-z","items":"wt-z","featureCss":"xt-z","disabled":"yt-z","imgCss":"zt-z"};